import { useNavigate, useSearchParams } from "react-router-dom";
import classes from "./SubscriptionPage2.module.css";
import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa6";
import { v4 as uuidv4 } from "uuid";
import SmallLoader from "../../component/SmallLoader";
import { loginApi } from "../../http/http";
import { setUserDetails } from "../../store/slices/userSlice";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const SubscriptionPage2 = () => {
  const [msisdn, setMsisdn] = useState("");
  const [loading, setLoading] = useState(false);
  const [extRef, setExtRef] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedPack, setSelectedPack] = useState("Daily");

  const {t}=useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector(state => state?.persisted?.userSlice);

  useEffect(() => {
    if (userDetails?.token) navigate("/home");
  }, [userDetails]);

  useEffect(() => {
    if (searchParams.get("ext_ref")) {
      setExtRef(searchParams.get("ext_ref"));
    } else {
      setSearchParams({ ext_ref: uuidv4() });
    }
  }, [searchParams]);

  const handleFormSubmission = async (e) => {
    e.preventDefault();
    if (msisdn?.trim().length === 0) return;
    try {
      setLoading(true);
      const response = await loginApi("1234");
      dispatch(setUserDetails(response?.data));
      setLoading(false);
      toast.success(t("20"));
      navigate("/home");
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message ||
        error?.response?.message ||
        error?.data?.message ||
        t("2")
      );
    }
  };

  return (
    <div className={classes.page}>

      {/* ══ LEFT — Brand Hero ══ */}
      <div className={classes.leftPanel}>
        <div className={classes.leftGrid} />
        <div className={classes.glowOrb} />
        <div className={classes.glowOrb2} />
        <div className={classes.vodaStrip} />

        {/* Logo */}
        <div className={classes.logo}>
          <div>
            <div className={classes.logoWordmark}>
            <img src="/assets/images/logo.png" alt="football" className={classes.logo_img} />

            </div>
            <div className={classes.logoPowered}>{t("3")} Door2Future Consultants Pvt Ltd</div>
          </div>
        </div>

        <p className={classes.heroEyebrow}>{t("21")}</p>
        <h1 className={classes.heroTitle}>
          {t("22")}
          <span className={classes.accent}>{t("23")}</span>
        <span className={classes.accent}>{t("24")}</span>
        </h1>
        <p className={classes.heroSub}>
          {t("25")}
        </p>

        <div className={classes.pillsRow}>
          <span className={classes.pill}>{t("26")}</span>
          <span className={classes.pill}>{t("27")}</span>
          <span className={classes.pill}>{t("28")}</span>
          <span className={classes.pill}>{t("29")}</span>
        </div>
      </div>

      {/* ══ RIGHT — Form ══ */}
      <div className={classes.rightPanel}>
        <div className={classes.rightGrid} />
        <div className={classes.formContainer}>

          <h2 className={classes.formTitle}>
            {t("30")} <span>{t("31")}</span>
          </h2>
          <p className={classes.formSubtitle}>
            {t("32")}
          </p>

          <div className={classes.tabToggle}>
            <button
              type="button"
              className={classes.tab}
              onClick={() => navigate(`/login?ext_ref=${extRef}`)}
            >
              {t("33")}
            </button>
            <button type="button" className={`${classes.tab} ${classes.activeTab}`}>
              {t("34")}
            </button>
          </div>

          <form onSubmit={handleFormSubmission}>
            <p className={classes.sectionLabel}>{t("35")}</p>
            <div className={classes.phoneRow}>
              <div className={classes.countryPill}>
                <img src="/assets/images/flag.png" alt="Tanzania" className={classes.flag} />
                <span className={classes.dialCode}>+255</span>
              </div>
              <input
                id="msisdn"
                name="msisdn"
                type="number"
                autoFocus
                onWheel={(e) => e.target.blur()}
                placeholder={t("36")}
                className={classes.phoneInput}
                onChange={(e) => setMsisdn(e.target.value)}
                value={msisdn}
              />
            </div>

            <div className={classes.plansSection}>
              <p className={classes.sectionLabel}>{t("37")}</p>
              <div className={classes.plansGrid}>

                <button
                  type="button"
                  className={`${classes.planCard} ${selectedPack === "Daily" ? classes.selDaily : ""}`}
                  onClick={() => setSelectedPack("Daily")}
                >
                  <span className={classes.planEmoji}>⚡</span>
                  <span className={classes.planName}>{t("38")}</span>
                  <span className={classes.planPrice}>{t("39")}</span>
                  <span className={classes.planDesc}>{t("40")}</span>
                  <div className={classes.radioRing}>
                    {selectedPack === "Daily" && <FaCheck className={classes.checkIcon} />}
                  </div>
                </button>

                <button
                  type="button"
                  className={`${classes.planCard} ${selectedPack === "Weekly" ? classes.selMonthly : ""}`}
                  onClick={() => setSelectedPack("Weekly")}
                >
                  {/* <span className={classes.badge}>Best Value</span> */}
                  <span className={classes.planEmoji}>🏆</span>
                  <span className={classes.planName}>{t("41")}</span>
                  <span className={classes.planPrice}>{t("42")}</span>
                  <span className={classes.planDesc}>{t("43")}</span>
                  <div className={classes.radioRing}>
                    {selectedPack === "Weekly" && <FaCheck className={classes.checkIcon} />}
                  </div>
                </button>

                    <button
                  type="button"
                  className={`${classes.planCard} ${selectedPack === "Monthly" ? classes.selMonthly : ""}`}
                  onClick={() => setSelectedPack("Monthly")}
                >
                  <span className={classes.badge}>{t("44")}</span>
                  <span className={classes.planEmoji}>🏆</span>
                  <span className={classes.planName}>{t("45")}</span>
                  <span className={classes.planPrice}>{t("46")}</span>
                  <span className={classes.planDesc}>{t("47")}</span>
                  <div className={classes.radioRing}>
                    {selectedPack === "Monthly" && <FaCheck className={classes.checkIcon} />}
                  </div>
                </button>

              </div>
            </div>

            <div className={classes.termsRow}>
              <input
                type="checkbox"
                id="terms"
                className={classes.termsCheck}
                checked
                readOnly
              />
              <label htmlFor="terms" className={classes.termsText}>
                {t("48")}{" "}
                <span className={classes.termsLink}>{t("49")} &amp; {t("50")}</span>
              </label>
            </div>

            <button type="submit" disabled={loading} className={classes.ctaBtn}>
              {loading
                ? <SmallLoader style={{ border: "4px solid #ffffff" }} />
                : <>{t("51")}</>
              }
            </button>
          </form>

          <div className={classes.copyrightFooter}>
            <div className={classes.copyrightDivider} />
            <div className={classes.copyrightInner}>
              <span className={classes.copyrightBadge}>
                <span className={classes.copyrightBadgeIcon}>⚽</span>
                 Vodacom Live Football Game
              </span>
              <p className={classes.copyrightText}>
                © {new Date().getFullYear()} Door2Future Consultants Pvt Ltd
              </p>
              <p className={classes.copyrightSub}>All rights reserved</p>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
};

export default SubscriptionPage2;